import type { CarListing, PartListing } from '@/types/marketplace.types'

export const PLACEHOLDER_CARS: CarListing[] = [
  {
    id: 'car-1',
    slug: 'apex-spider-v8-grand-coupe',
    title: 'Apex Spider V8 Grand Coupe',
    subtitle: 'Certified Dealer Inventory Highlight',
    price: 245000,
    priceText: '$245,000',
    emiText: '$3,850 / month EMI option available',
    badgeText: 'Dealer Verified',
    verified: true,
    featured: true,
    brand: 'Apex',
    model: 'Spider V8',
    year: 2025,
    mileage: '1,200 mi',
    kilometers: 1930,
    fuel: 'V8 Hybrid',
    transmission: '8-Speed DCT',
    bodyType: 'Coupe',
    ownership: 'First Owner',
    location: 'Detroit, MI',
    color: 'Onyx Black',
    engine: '4.0L Twin-Turbo V8 Hybrid',
    power: '780 HP',
    description:
      'The Apex Spider V8 Grand Coupe combines racing aerodynamics with ultra-luxury cabin refinement. Maintained in climate-controlled garage, complete dealer service history, and extended factory warranty included.',
    images: [
      'https://images.unsplash.com/photo-1617788138017-80ad40651399?auto=format&fit=crop&w=1200&q=80',
      'https://images.unsplash.com/photo-1503376780353-7e6692767b70?auto=format&fit=crop&w=800&q=80',
      'https://images.unsplash.com/photo-1544829099-b9a0c07fad1a?auto=format&fit=crop&w=800&q=80',
      'https://images.unsplash.com/photo-1552519507-da3b142c6e3d?auto=format&fit=crop&w=800&q=80',
    ],
    specs: {
      year: '2025',
      mileage: '1,200 mi',
      fuel: 'V8 Hybrid',
      transmission: '8-Speed DCT',
      engine: '4.0L Twin-Turbo V8 Hybrid',
      power: '780 HP',
      seats: 2,
      color: 'Onyx Black',
    },
    features: [
      'Carbon Ceramic Brakes',
      'Active Aerodynamic Wing',
      'Alcantara & Nappa Interior',
      'Launch Control System',
      '360 Surround View Cameras',
      'Burmester 3D Surround Audio',
    ],
    seller: {
      name: 'Apex Prestige Dealership',
      type: 'Dealer',
      phone: '+1 (800) 555-APEX',
      email: 'sales@apexmotors.com',
      location: 'Detroit, MI',
      rating: 4.9,
      verified: true,
    },
  },
  {
    id: 'car-2',
    slug: 'monarch-gtr-carbon-edition',
    title: 'Monarch GTR Carbon Edition',
    subtitle: 'Verified Private Seller Listing',
    price: 189500,
    priceText: '$189,500',
    emiText: '$2,950 / month EMI option available',
    badgeText: 'Verified Seller',
    verified: true,
    featured: true,
    brand: 'Monarch',
    model: 'GTR',
    year: 2024,
    mileage: '4,500 mi',
    kilometers: 7240,
    fuel: 'Twin Turbo V6',
    transmission: 'Automatic',
    bodyType: 'Coupe',
    ownership: 'First Owner',
    location: 'Miami, FL',
    color: 'Crimson Red',
    engine: '3.8L Twin-Turbo V6',
    power: '650 HP',
    description:
      'Pristine condition Monarch GTR Carbon Edition featuring full factory carbon weave body kit, forged monoblock wheels, titanium exhaust package, and ceramic coating.',
    images: [
      'https://images.unsplash.com/photo-1552519507-da3b142c6e3d?auto=format&fit=crop&w=1200&q=80',
      'https://images.unsplash.com/photo-1617788138017-80ad40651399?auto=format&fit=crop&w=800&q=80',
      'https://images.unsplash.com/photo-1503376780353-7e6692767b70?auto=format&fit=crop&w=800&q=80',
    ],
    specs: {
      year: '2024',
      mileage: '4,500 mi',
      fuel: 'Twin Turbo V6',
      transmission: 'Automatic',
      engine: '3.8L Twin-Turbo V6',
      power: '650 HP',
      seats: 4,
      color: 'Crimson Red',
    },
    features: [
      'Full Carbon Weave Package',
      'Titanium Sport Exhaust',
      'Heated & Ventilated Sport Seats',
      'Track Telemetry System',
      'Apple CarPlay & Android Auto',
    ],
    seller: {
      name: 'Marcus Vance',
      type: 'Private Seller',
      phone: '+1 (305) 555-0192',
      email: 'marcus.vance@example.com',
      location: 'Miami, FL',
      rating: 5.0,
      verified: true,
    },
  },
  {
    id: 'car-3',
    slug: 'veritas-ev-performance-gt',
    title: 'Veritas EV Performance GT',
    subtitle: 'Brand New Dealer Stock',
    price: 135000,
    priceText: '$135,000',
    emiText: '$2,100 / month EMI option available',
    badgeText: 'Brand New',
    verified: true,
    featured: false,
    brand: 'Veritas',
    model: 'EV GT',
    year: 2026,
    mileage: '15 mi',
    kilometers: 24,
    fuel: 'All-Electric',
    transmission: 'Single Speed',
    bodyType: 'Sedan',
    ownership: 'Brand New',
    location: 'Los Angeles, CA',
    color: 'Matte Titanium',
    engine: 'Tri-Motor Electric AWD',
    power: '1020 HP',
    description:
      'Next-generation luxury EV sedan with 420-mile range capability, 0-60 in 1.99s, dual ultra-wide cockpit screens, and autonomous highway cruising package.',
    images: [
      'https://images.unsplash.com/photo-1544829099-b9a0c07fad1a?auto=format&fit=crop&w=1200&q=80',
      'https://images.unsplash.com/photo-1617788138017-80ad40651399?auto=format&fit=crop&w=800&q=80',
    ],
    specs: {
      year: '2026',
      mileage: '15 mi',
      fuel: 'All-Electric',
      transmission: 'Single Speed',
      engine: 'Tri-Motor AWD',
      power: '1020 HP',
      seats: 5,
      color: 'Matte Titanium',
    },
    features: [
      '400+ Mile EPA Range',
      'Adaptive Air Suspension',
      'Glass Panorama Roof',
      'Level 3 Autopilot Suite',
    ],
    seller: {
      name: 'Veritas Motors LA',
      type: 'Dealer',
      phone: '+1 (310) 555-8800',
      email: 'la@veritascars.com',
      location: 'Los Angeles, CA',
      rating: 4.8,
      verified: true,
    },
  },
  {
    id: 'car-4',
    slug: 'aura-phantom-v12-hyper-coupe',
    title: 'Aura Phantom V12 Hyper Coupe',
    subtitle: 'Limited Edition 1 of 50',
    price: 320000,
    priceText: '$320,000',
    emiText: '$5,100 / month EMI option available',
    badgeText: 'Collector Grade',
    verified: true,
    featured: true,
    brand: 'Aura',
    model: 'Phantom V12',
    year: 2025,
    mileage: '500 mi',
    kilometers: 805,
    fuel: 'Naturally Aspirated V12',
    transmission: '7-Speed Sequential',
    bodyType: 'Coupe',
    ownership: 'First Owner',
    location: 'New York, NY',
    color: 'Midnight Purple',
    engine: '6.5L NA V12',
    power: '830 HP',
    description:
      'Rare limited production NA V12 supercar. Full custom leather craftsmanship, exposed carbon chassis, and custom luggage set included.',
    images: [
      'https://images.unsplash.com/photo-1503376780353-7e6692767b70?auto=format&fit=crop&w=1200&q=80',
    ],
    specs: {
      year: '2025',
      mileage: '500 mi',
      fuel: 'Naturally Aspirated V12',
      transmission: '7-Speed Sequential',
      engine: '6.5L NA V12',
      power: '830 HP',
      seats: 2,
      color: 'Midnight Purple',
    },
    features: [
      'Carbon Monocoque Chassis',
      'Custom Bespoke Interior',
      'Racing Telemetry Pack',
    ],
    seller: {
      name: 'Manhattan Exotic Cars',
      type: 'Dealer',
      phone: '+1 (212) 555-0199',
      email: 'vip@manhattanexotics.com',
      location: 'New York, NY',
      rating: 4.9,
      verified: true,
    },
  },
]

export const PLACEHOLDER_PARTS: PartListing[] = [
  {
    id: 'part-1',
    slug: 'titanium-quad-performance-exhaust-system',
    title: 'Titanium Quad Performance Exhaust System',
    partNumber: 'OEM-EX-992-TITAN',
    price: 4850,
    priceText: '$4,850',
    category: 'Exhaust Systems',
    brand: 'Apex Performance',
    compatibility: ['Apex Spider V8', 'Monarch GTR', 'Veritas GT'],
    isOEM: true,
    ratingText: '4.9 (48 Reviews)',
    rating: 4.9,
    reviewsCount: 48,
    inStock: true,
    stockCount: 14,
    warranty: '3 Years / 36,000 Miles Manufacturer Warranty',
    shippingInfo: 'Free Express Shipping Nationwide (2-4 Business Days)',
    returnPolicy: '30-Day Money Back Guarantee with zero restocking fees',
    description:
      'Ultra lightweight grade-5 titanium exhaust system engineered to reduce backpressure by 42% while producing an aggressive motorsport acoustics. Mandrel-bent piping with hand-welded joints.',
    specifications: {
      Material: 'Grade 5 Titanium',
      Weight: '18.4 lbs (45% lighter than stock)',
      TipFinish: 'Burnt Blue Titanium',
      Fitment: 'Direct Bolt-On OEM Replacement',
    },
    images: [
      'https://images.unsplash.com/photo-1542282088-72c9c27ed0cd?auto=format&fit=crop&w=1200&q=80',
      'https://images.unsplash.com/photo-1486006920555-c77dce18193b?auto=format&fit=crop&w=1200&q=80',
      'https://images.unsplash.com/photo-1580273916550-e323be2ae537?auto=format&fit=crop&w=1200&q=80',
    ],
    seller: {
      name: 'Official Apex Parts Supply',
      type: 'Authorized OEM Distributor',
      rating: 4.9,
      location: 'Detroit, MI',
    },
  },
  {
    id: 'part-2',
    slug: 'carbon-ceramic-brake-rotor-caliper-kit',
    title: 'Carbon Ceramic Brake Rotor & Caliper Kit',
    partNumber: 'OEM-BRK-CCM-04',
    price: 7200,
    priceText: '$7,200',
    category: 'Braking System',
    brand: 'Brembo OEM',
    compatibility: ['Monarch GTR', 'Aura Phantom', 'Apex Spider V8'],
    isOEM: true,
    ratingText: '5.0 (32 Reviews)',
    rating: 5.0,
    reviewsCount: 32,
    inStock: true,
    stockCount: 6,
    warranty: '2 Years Factory Warranty',
    shippingInfo: 'Insured Freight Freight Shipping Included',
    returnPolicy: '30-Day Unopened Returns Allowed',
    description:
      'Track-proven carbon ceramic braking system delivering fade-free performance up to 1,800°F. Includes 6-piston front calipers, 4-piston rear calipers, and braided stainless steel brake lines.',
    specifications: {
      RotorDiameter: '410mm Front / 390mm Rear',
      CaliperColor: 'Race Red',
      PadType: 'Carbon-Metallic Track Compound',
    },
    images: [
      'https://images.unsplash.com/photo-1486006920555-c77dce18193b?auto=format&fit=crop&w=1200&q=80',
      'https://images.unsplash.com/photo-1542282088-72c9c27ed0cd?auto=format&fit=crop&w=1200&q=80',
    ],
    seller: {
      name: 'High Performance Auto Parts',
      type: 'Certified Dealer',
      rating: 5.0,
      location: 'Chicago, IL',
    },
  },
  {
    id: 'part-3',
    slug: 'forged-monoblock-21-wheels-set',
    title: 'Forged Monoblock 21" Wheels Set',
    partNumber: 'WHL-21-MONO-BLK',
    price: 5400,
    priceText: '$5,400',
    category: 'Wheels & Rims',
    brand: 'Apex Racing',
    compatibility: ['Apex Spider V8', 'Veritas EV GT', 'Monarch GTR'],
    isOEM: false,
    ratingText: '4.8 (64 Reviews)',
    rating: 4.8,
    reviewsCount: 64,
    inStock: true,
    stockCount: 8,
    warranty: 'Lifetime Structural Warranty',
    shippingInfo: 'Standard Ground Shipping (3-5 Days)',
    returnPolicy: '15-Day Fitment Verification Return Policy',
    description:
      'Precision aerospace 6061-T6 forged aluminum wheels designed for maximum strength and minimal rotational inertia. Satin black anodized finish.',
    specifications: {
      Size: '21x9.5 Front / 21x11.5 Rear',
      BoltPattern: '5x112',
      Finish: 'Satin Anodized Black',
    },
    images: [
      'https://images.unsplash.com/photo-1580273916550-e323be2ae537?auto=format&fit=crop&w=1200&q=80',
      'https://images.unsplash.com/photo-1503376780353-7e6692767b70?auto=format&fit=crop&w=1200&q=80',
    ],
    seller: {
      name: 'Velocity Alloy Depot',
      type: 'Aftermarket Partner',
      rating: 4.8,
      location: 'Dallas, TX',
    },
  },
]
